import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    AuditLog,
    AuditLogListRequest,
    UserActivityRequest,
    UserActivityResponse,
    AuditLogAction,
    AuditLogResult
} from '../types_admin/audit_logs'

/**
 * 审计日志管理 API
 */
export const adminAuditLogsApi = {
    /**
     * 获取审计日志列表
     * GET /api/permissions/audit-logs/
     */
    getAuditLogList(params?: AuditLogListRequest): Promise<PaginationData<AuditLog>> {
        const queryParams: Record<string, unknown> = {}

        if (params?.page) queryParams.page = params.page
        if (params?.page_size) queryParams.page_size = params.page_size

        // 将filters对象转换为JSON字符串
        if (params?.filters) {
            queryParams.filters = JSON.stringify(params.filters)
        }

        return http.list('/api/permissions/audit-logs/', queryParams)
    },

    /**
     * 获取用户活动记录
     * GET /api/permissions/audit-logs/user-activity/
     */
    getUserActivity(params: UserActivityRequest): Promise<UserActivityResponse> {
        const queryString = new URLSearchParams()
        queryString.append('user_id', params.user_id.toString())

        if (params.limit) queryString.append('limit', params.limit.toString())
        if (params.days) queryString.append('days', params.days.toString())

        const url = `/api/permissions/audit-logs/user-activity/?${queryString.toString()}`
        return http.get(url)
    },

    /**
     * 获取操作类型选项（用于前端下拉选择）
     */
    getActionChoices(): Array<{ value: AuditLogAction; label: string }> {
        return [
            { value: 'grant_role', label: '分配角色' },
            { value: 'revoke_role', label: '撤销角色' },
            { value: 'grant_permission', label: '分配权限' },
            { value: 'revoke_permission', label: '撤销权限' },
            { value: 'check_permission', label: '权限检查' }
        ]
    },

    /**
     * 获取操作结果选项（用于前端下拉选择）
     */
    getResultChoices(): Array<{ value: AuditLogResult; label: string }> {
        return [
            { value: 'success', label: '成功' },
            { value: 'failed', label: '失败' },
            { value: 'denied', label: '拒绝' }
        ]
    }
}
